module.exports = __webpack_public_path__ + "media/operational-planning_en_ipad_old.0caac9eb.mp4";